import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xiaoxi",
  "use": "icon-xiaoxi-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-xiaoxi\"><path d=\"M10 17.5H8.333L3.75 20v-4.583C1.465 13.813 0 11.511 0 8.75 0 3.918 4.477 0 10 0c5.522 0 10 3.918 10 8.75 0 4.833-4.477 8.75-10 8.75zm0-16.25c-4.832 0-8.75 3.358-8.75 7.5C1.25 11.29 2.743 13.643 5 15v2.777l3.333-1.527h1.666c4.833 0 8.751-3.358 8.751-7.5 0-4.143-3.918-7.5-8.75-7.5zM15 10a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm-5 0a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm-5 0a1.25 1.25 0 110-2.5A1.25 1.25 0 015 10z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/xiaoxi.svg
// module id = 526
// module chunks = 4